import { render, staticRenderFns } from "./ModuleIframeForm.vue?vue&type=template&id=ae5de8fe&scoped=true"
import script from "./ModuleIframeForm.vue?vue&type=script&lang=js"
export * from "./ModuleIframeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae5de8fe",
  null
  
)

export default component.exports